exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-text[data-v-64dad576]{bottom:0;left:0;right:0;text-align:center}", ""]);

// exports
